import { LineShopProduct } from './types'

type Input = {
  productId: string | number
  productName: string
  amount: number | string
  productType?: string
  subCategory1?: string
  subCategory2?: string
}

// 將內部商品資料正規化成 LINE 購物規格：
// - product_amount 必須是非負整數、不含貨幣/千分位/小數點
// - 沒有分類時 sub_category 不回拋
export const toLineShopProduct = ({ productId, productName, amount, productType, subCategory1, subCategory2 }: Input): LineShopProduct => {
  const numericAmount = Math.max(0, Math.floor(Number(amount) || 0))

  return {
    product_name: productName,
    product_type: productType || 'normal',
    product_id: String(productId),
    product_amount: numericAmount,
    ...(subCategory1 ? { sub_category1: subCategory1 } : {}),
    ...(subCategory2 ? { sub_category2: subCategory2 } : {}),
  }
}
